<script setup lang="ts">
import { computed } from 'vue'
import { usePermissionsStore } from '@/stores/permissions'
import type { ActionKey } from '@/types'
import FosTooltip from './FosTooltip.vue'

const props = defineProps<{
  action: ActionKey
  role: string | null | undefined
}>()

const permissionsStore = usePermissionsStore()

const allowed = computed(() => permissionsStore.can(props.action, props.role))

const tooltip = computed(() => {
  const required = permissionsStore.requiredRolesFor(props.action)
  const roleLabel = props.role ?? 'unknown'
  return `Your role (${roleLabel}) cannot do this. Requires: ${required.join(', ')}`
})
</script>

<template>
  <FosTooltip v-if="!allowed" :content="tooltip">
    <span class="pointer-events-none opacity-50 select-none inline-flex">
      <slot />
    </span>
  </FosTooltip>
  <slot v-else />
</template>
